import { Driver, DriverHook } from "driver.js";
import { defaultTourConfig } from ".";

// Export the tour steps so they can be reused in BrandGrandTour
export const brandReveshareResourcesTourSteps = [
  {
    element: "#reveshare-resources",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
          <div class="flex -space-x-2">
            <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
              </svg>
            </div>
            <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
              </svg>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-base font-semibold text-foreground">Reveshare Resources</span>
          </div>
        </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground leading-relaxed">Your complete playbook for building an organic e-commerce empire — written by Dylan Torpey, founder of Visionary Fitness and Reveshare.</p>
          <div class="bg-brand-100 p-3 rounded-lg border border-brand-200">
            <div class="flex items-start gap-2">
              <svg class="w-4 h-4 text-brand-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <div class="text-xs text-brand-800">
                <span class="font-medium">Pro Tip:</span> This guide includes navigable sections with a table of contents — click any section to jump directly to that content.
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2 text-xs text-brand-600">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>
            <span>Everything Dylan learned building Visionary Fitness to 7-figures organically — zero paid ads</span>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
];

const startReveshareResourcesTour = (
  tourDriver: Driver,
  onNextClick: DriverHook,
  onPrevClick: DriverHook
) => {
  tourDriver.setConfig(defaultTourConfig);
  // Here we set the unique steps for the Reveshare Resources tour
  tourDriver.setSteps(
    brandReveshareResourcesTourSteps.map((step) => ({
      ...step,
      popover: {
        ...step.popover,
        onNextClick: (element, step, config) => {
          onNextClick(element, step, config);
          setTimeout(() => {
            tourDriver.moveNext();
          }, 200);
        },
        onPrevClick: (element, step, config) => {
          onPrevClick(element, step, config);
          setTimeout(() => {
            tourDriver.movePrevious();
          }, 200);
        },
      },
    }))
  );
  tourDriver.drive();
};

export default startReveshareResourcesTour;
